import axios from 'axios';
import {API_TRIBUTUM_CLIENTE_ID, API_TRIBUTUM_PASSWORD, API_TRIBUTUM_URL, API_TRIBUTUM_USER} from '@constants';

interface TokenData {
    token: string | null;
    expirationTime: number | null;
}

interface TributumAuthResponse {
    token_acesso: string;
}

let tokenData: TokenData = {
    token: null,
    expirationTime: null,
};

export async function getTokenFromTributum() {
    if (tokenData.token && tokenData.expirationTime !== null && tokenData.expirationTime > Date.now()) {
        return tokenData.token;
    }
    try {
        const response = await axios.post<TributumAuthResponse>(
            `${API_TRIBUTUM_URL}/auth/login/`,
            {
                conta_nome: API_TRIBUTUM_CLIENTE_ID,
                identificacao: API_TRIBUTUM_USER,
                senha: API_TRIBUTUM_PASSWORD,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
            }
        );

        const {token_acesso} = response.data;
        const expirationTime = Date.now() + (1000 * 1000);

        tokenData = {
            token: token_acesso,
            expirationTime,
        };

        return token_acesso;
    } catch (error) {
        console.error('Failed to retrieve token', error);
        throw error;
    }
}
